import axios from 'axios'
import { Toast } from 'vant'
import router from '../router/index'
// import config from '../../public/config'

axios.defaults.baseURL = window.g.BASE_API
// axios.defaults.baseURL = 'http://192.168.0.111:8088/'
// 设置超时时间和跨域是否携带凭证
axios.defaults.timeout = 30000
// 设置CORS跨域允许携带凭证
// axios.defaults.withCredentials = true

// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.transformRequest = data => qs.stringify(data)

// 设置请求拦截器
// 客户端发送请求=》请求拦截器=》服务器
// TOKEN校验（JWT）接收服务器返回的token
// 存储到vuex/本地存储中，每一次发请求我们应该吧token带上
const whiteList = [
  'subscribeList',
  'notice',
  'subscribeDetails',
  'agreement',
  'question',
  'claims',
  'appointmentDetails',
  'login'
]
axios.interceptors.request.use((config) => {
  if (!whiteList.includes(router.history.current.name) || (router.history.current.name === 'appointmentDetails' && router.history.current.query.type)) {
    // 若非白名单的路由页面，所有请求都携带上token
    const Authorization = localStorage.getItem('Authorization_yy')
    //   const Authorization = 'ea64a61aa4ce4b0c859abc5ddef5ce2c'
    Authorization && (config.headers.Authorization = Authorization)
  }

  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
// 服务器返回信息=》拦截的统一处理=》客户端js获取到信息
// axios.defaults.validatestatus=status=>{
// 自定义响应成功的http状态码
//     return /^(2|3)\d{2}$/.test(status)
// }
axios.interceptors.response.use(response => {
  if (response.data && response.data.status === 1) {
    if (response.config.url === 'bacc/report/login') localStorage.Authorization_yy = response.headers.authorization
    return response.data
  } else {
    if (response.config.url === 'bacc/idCard/getIdCardInfoForSub' || response.config.url === 'bacc/idCard/addressAnalysis' || response.config.url === 'bacc/idCard/idcardAddressAnalysis') {
      return response.data
    }
    if (response.config.url === 'bacc/userCaseHistory/sendToCheck1') return Promise.reject(response.data.message)
    // return response.data
    Toast(
      {
        type: 'fail',
        message: response.data.message,
        forbidClick: true,
        onClose: () => {
          if (response.data.message === '权限错误') {
            location.href = '#/login'
          }
        }
      })
  }
  // 看项目实际情况，这样写返回的数据就只有主体内容
}, error => {
  const { response } = error
  if (response) {
    // 服务器最起码返回结果
    switch (response.status) {
      case 401://= >权限问题，当前请求需要用户验证，一般是未登陆
        break
      case 403://= >服务器已经理解请求，但是拒绝执行他，一般是token过期或session过期
        localStorage.removeItem('Authorization_yy')
        break
      case 404://= >找不到页面
        break
    }
  } else {
    // 服务器连结果都没有返回
    if (!window.navigator.onLine) {
      // 如果客户端断网了:可以跳转到断网页面
      return
    }
    return Promise.reject(error)
    // 可能是服务器错误返回一个promise
  }
})

export default axios
